import React from 'react'
import "./newteam.css";
import {FaFacebookF, FaTwitter, FaLinkedinIn, FaInstagram, FaGithub} from 'react-icons/fa'

import siddharth from '../../assets/POR/Samosa - Director operations.jpg';
import Ananay from '../../assets/PR/Ananay- Execomm.jpg'
import risroy from '../../assets/PR/RishabhRoy- Execomm.jpg'
import ruch from '../../assets/PR/RuchirKundra-Execom.jpg'
import yashum from '../../assets/PR/Yashum Bajaj_ Execomm.jpg'

const Newteam = () => {
  return (
    <>
    <h2 className="main-title">PR Team</h2>
    <div class="nnn">
    <div className="cont">
        <div className="cards">
          <div className="imgbox">
            <img src={siddharth} alt="" />
          </div>
          <div className="content">
            <div className="details">
              <h2>Siddharth Varshney <br /><span>web developer</span></h2>
              <ul className="social_media">
              <li><a href="#"><FaInstagram className="i" /></a></li>
                <li><a href="#"><FaLinkedinIn className="i" /></a></li>
                <li><a href="#"><FaFacebookF className="i" /></a></li>
                {/* <li><a href="#"><FaGithub className="i" /></a></li> */}
              </ul>
            </div>
          </div>
        </div>

        <div className="cards">
          <div className="imgbox">
            <img src={Ananay} alt="" />
          </div>
          <div className="content">
            <div className="details">
              <h2>Ananay <br /><span>web developer</span></h2>
              <ul className="social_media">
              <li><a href="#"><FaInstagram className="i" /></a></li>
                <li><a href="#"><FaLinkedinIn className="i" /></a></li>
                <li><a href="#"><FaFacebookF className="i" /></a></li>
                {/* <li><a href="#"><FaGithub className="i" /></a></li> */}
              </ul>
            </div>
          </div>
        </div>

        <div className="cards">
          <div className="imgbox">
            <img src={risroy} alt="" />
          </div>
          <div className="content">
            <div className="details">
              <h2>Rishabh Roy <br /><span>web developer</span></h2>
              <ul className="social_media">
              <li><a href="#"><FaInstagram className="i" /></a></li>
                <li><a href="#"><FaLinkedinIn className="i" /></a></li>
                <li><a href="#"><FaFacebookF className="i" /></a></li>
                {/* <li><a href="#"><FaGithub className="i" /></a></li> */}
              </ul>
            </div>
          </div>
        </div>

        <div className="cards">
          <div className="imgbox">
            <img src={ruch} alt="" />
          </div>
          <div className="content">
            <div className="details">
              <h2>Ruchir Kundra <br /><span>web developer</span></h2>
              <ul className="social_media">
              <li><a href="#"><FaInstagram className="i" /></a></li>
                <li><a href="#"><FaLinkedinIn className="i" /></a></li>
                <li><a href="#"><FaFacebookF className="i" /></a></li>
                {/* <li><a href="#"><FaGithub className="i" /></a></li> */}
              </ul>
            </div>
          </div>
        </div>


        <div className="cards">
          <div className="imgbox">
            <img src={yashum} alt="" />
          </div>
          <div className="content">
            <div className="details">
              <h2>Yashum Bajaj <br /><span>web developer</span></h2>
              <ul className="social_media">
              <li><a href="#"><FaInstagram className="i" /></a></li>
                <li><a href="#"><FaLinkedinIn className="i" /></a></li>
                <li><a href="#"><FaFacebookF className="i" /></a></li>
                {/* <li><a href="#"><FaGithub className="i" /></a></li> */}
              </ul>
            </div>
          </div>
        </div>

    

      </div>
      </div>
    </>
  )
}

export default Newteam